module.exports = __webpack_public_path__ + "img/maitrise_623x300.ca402a99.png";